import React from "react";
import { injectIntl } from "react-intl";
import filesize from "filesize";

import { Container, Row, Column } from "../Grid";
import Heading from "../Heading";
import { ActionBar } from "../ActionBar";
import {
  withApi,
  apiShape,
  withBackend,
  backendShape,
  notifierShape,
  withNotifier,
  withConfiguration,
} from "../../context";
import { Clue } from "../Clue";
import { intlShape } from "../../shapes";
import { Details, DetailsItem } from "../Details";
import { formatDateTime } from "../../utils";
import { iconForFileName } from "../../utils/fileUtils";
import Loader from "../Loader";
import Clickable from "../Clickable";
import Comments from "./Comments";

import TicketAttachmentsForm from "./TicketAttachmentsForm";

type Props = {
  api?: apiShape;
  intl?: intlShape;
  backend?: backendShape;
  notifier?: notifierShape;
  configuration: {
    language: string;
  };
  match?: {
    params: {
      id?: string;
    };
  };
};

export function TicketDetails({
  api,
  backend,
  intl,
  notifier,
  match,
  configuration,
}: Props) {
  // @ts-expect-error TS(2532) FIXME: Object is possibly 'undefined'.
  const { id } = match.params;
  const [ticket, setTicket] = React.useState();
  const [attachments, setAttachments] = React.useState();
  const [comments, setComments] = React.useState();

  React.useEffect(() => {
    const loadData = async () => {
      try {
        // @ts-expect-error TS(2532) FIXME: Object is possibly 'undefined'.
        const response = await backend.get(`/support/tickets/${id}`, {
          language: configuration.language,
        });
        // @ts-expect-error TS(2532) FIXME: Object is possibly 'undefined'.
        const responseComments = await backend.get(
          `/support/tickets/${id}/comments`,
        );
        // @ts-expect-error TS(2532) FIXME: Object is possibly 'undefined'.
        const responseAttachments = await backend.get(
          `/support/tickets/${id}/attachments`,
        );
        setTicket(response);
        setAttachments(responseAttachments.attachments);
        setComments(responseComments.comments);
      } catch (error) {
        // @ts-expect-error TS(2532) FIXME: Object is possibly 'undefined'.
        notifier.showError(api.translateError(error));
      }
    };

    loadData();
  }, [id]);

  const closedTicket = (ticket as $TSFixMe)?.status === "closed";

  const downloadAttachment = async (attachmentId: $TSFixMe, name: $TSFixMe) => {
    // @ts-expect-error TS(2532) FIXME: Object is possibly 'undefined'.
    const response = await backend.get(
      `/support/attachments/${attachmentId}/download`,
      {},
      false,
      "arraybuffer",
    );
    const file = new Blob([response]);
    // IE doesn't allow using a blob object directly as link href
    // instead it is necessary to use msSaveOrOpenBlob
    /* istanbul ignore next */
    if (window.navigator && (window.navigator as $TSFixMe).msSaveOrOpenBlob) {
      (window.navigator as $TSFixMe).msSaveOrOpenBlob(file, name);
      return;
    }
    const url = window.URL.createObjectURL(file);
    const a = document.createElement("a");
    a.href = url;
    a.download = name;
    a.click();
  };

  const renderClickableAttachment = (attachment: $TSFixMe) => {
    const clickableName = (
      <Clickable
        className="left-clickable"
        onClick={() => {
          downloadAttachment(attachment.id, attachment.name);
        }}
      >
        {attachment.name}
      </Clickable>
    );
    return (
      <div key={attachment.id} className="list-item">
        <div className="list-item-icon">
          <span className={` icon ${iconForFileName(attachment.name)}`} />
        </div>
        <div className="list-item-content">
          <div id="ticket-attachment-header" className="list-item-header-only">
            {clickableName}
          </div>
          <div>
            {filesize(attachment.body_length)}
            {" - "}
            {formatDateTime(attachment.created_at, intl)}
            {" - "}
            {attachment.created_by}
          </div>
        </div>
      </div>
    );
  };

  const submitComment = async (values: $TSFixMe, actions: $TSFixMe) => {
    try {
      // @ts-expect-error TS(2532) FIXME: Object is possibly 'undefined'.
      const response = await backend.post(
        `/support/tickets/${id}/comments`,
        values,
      );
      // @ts-expect-error TS(2532) FIXME: Object is possibly 'undefined'.
      notifier.showSuccess(
        // @ts-expect-error TS(2532) FIXME: Object is possibly 'undefined'.
        intl.formatMessage({
          id: "support.ticket.create_comment.success_notification",
        }),
      );
      // @ts-expect-error TS(2532) FIXME: Object is possibly 'undefined'.
      setComments(comments.concat([{ ...{ ...response } }]));
      actions.resetForm({ values: {} });
    } catch (error) {
      // @ts-expect-error TS(2532) FIXME: Object is possibly 'undefined'.
      notifier.showError(api.translateError(error));
    } finally {
      actions.setSubmitting(false);
    }
  };

  const showNewAttachments = (newAttachments: $TSFixMe) => {
    // @ts-expect-error TS(2532) FIXME: Object is possibly 'undefined'.
    setAttachments(attachments.concat(newAttachments));
  };

  return (
    <Container>
      <Row>
        <Column>
          <ActionBar>
            <Heading
              id="ticket-header"
              // @ts-expect-error TS(2532) FIXME: Object is possibly 'undefined'.
              title={intl.formatMessage({
                id: "support.ticket.details.header",
              })}
            />
          </ActionBar>
          {ticket && (
            <Details>
              <DetailsItem
                id="ticket-number"
                translationKey="label.number"
                value={(ticket as $TSFixMe).number}
              />
              <DetailsItem
                id="ticket-created-at"
                translationKey="label.created_at"
                value={formatDateTime((ticket as $TSFixMe).created_at, intl)}
              />
              <DetailsItem
                id="ticket-updated-at"
                translationKey="label.updated_at"
                value={formatDateTime((ticket as $TSFixMe).updated_at, intl)}
              />
              <DetailsItem
                id="ticket-status"
                translationKey="label.status"
                // @ts-expect-error TS(2532) FIXME: Object is possibly 'undefined'.
                value={intl.formatMessage({
                  id: `support.status.${(ticket as $TSFixMe).status}`,
                })}
              />
              <DetailsItem
                id="ticket-subject"
                translationKey="label.subject"
                value={(ticket as $TSFixMe).subject}
              />
              <DetailsItem
                id="ticket-description"
                translationKey="label.description"
                value={(ticket as $TSFixMe).description}
                className="support-wrap"
              />
            </Details>
          )}
          {attachments && (
            <div>
              <ActionBar>
                <Heading
                  level={2}
                  id="ticket-attachments-header"
                  // @ts-expect-error TS(2532) FIXME: Object is possibly 'undefined'.
                  title={intl.formatMessage({
                    id: "support.ticket.attachments.header",
                  })}
                />
              </ActionBar>
              {(attachments as $TSFixMe).length > 0 ? (
                <div id="ticket-attachments-list" className="list space-after">
                  {(attachments as $TSFixMe).map((attachment: $TSFixMe) =>
                    renderClickableAttachment(attachment),
                  )}
                </div>
              ) : (
                <Clue
                  // @ts-expect-error TS(2532) FIXME: Object is possibly 'undefined'.
                  details={intl.formatMessage({
                    id: "support.tickets.no_attachments",
                  })}
                />
              )}
              {!closedTicket && (
                <TicketAttachmentsForm
                  // @ts-expect-error TS(2322) FIXME: Type '{ id: string; ticketId: string | undefined; ... Remove this comment to see the full error message
                  id="ticket-attachment-Form"
                  ticketId={id}
                  returnResponse={showNewAttachments}
                />
              )}
            </div>
          )}
          {ticket && (
            <Comments
              // @ts-expect-error TS(2322) FIXME: Type '{ comments: undefined; showCreateForm: boole... Remove this comment to see the full error message
              comments={comments}
              showCreateForm={!closedTicket}
              onSubmit={submitComment}
            />
          )}
          <Loader loading={!ticket || !attachments || !comments} />
        </Column>
      </Row>
    </Container>
  );
}

export default withApi(
  // @ts-expect-error TS(2345) FIXME: Argument of type 'ForwardRefExoticComponent<Omit<W... Remove this comment to see the full error message
  withNotifier(withBackend(withConfiguration(injectIntl(TicketDetails)))),
);
